import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { SpaceConfigProvider } from './context/SpaceConfigContext';
import { LocalizationProvider } from "./context/LocalizationContext";
import { SpaceProvider } from "./context/SpaceContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { ToastProvider } from "./context/ToastContext";
import { ApprovalProvider } from "./context/ApprovalContext";
import { NavigationGuardProvider } from "./context/NavigationGuardContext";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msalInstance';

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  event.preventDefault();
});

const hashParams = new URLSearchParams(window.location.hash.slice(1));
const redirectAuthError = hashParams.get("error_description");
if (redirectAuthError) {
  sessionStorage.setItem(
    "msal_redirect_error",
    decodeURIComponent(redirectAuthError.replace(/\+/g, " "))
      .split(" Trace ID:")[0]
      .split(" Correlation ID:")[0]
  );
}

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        {/* AuthProvider is outermost data provider so data contexts can read activeSpace */}
        <AuthProvider>
          <SpaceConfigProvider>
          <LocalizationProvider>
            <SpaceProvider>
              <CurrencyProvider>
                <ToastProvider>
                  <ApprovalProvider>
                    <NavigationGuardProvider>
                      <React.StrictMode>
                        <App />
                      </React.StrictMode>
                    </NavigationGuardProvider>
                  </ApprovalProvider>
                </ToastProvider>
              </CurrencyProvider>
            </SpaceProvider>
          </LocalizationProvider>
          </SpaceConfigProvider>
        </AuthProvider>
      </ThemeProvider>
    </MsalProvider>
  );
  reportWebVitals();
};

msalInstance.initialize().then(renderApp).catch(renderApp);
